/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import CDSStructuredListHeaderCell from '@carbon/web-components/es/components/structured-list/structured-list-header-cell.js';
import {} from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './structured-list.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * StructuredListHeaderCell
 *
 * @element c4d-structured-list-header-cell
 */
@customElement(`${c4dPrefix}-structured-list-header-cell`)
class C4DStructuredListHeaderCell extends CDSStructuredListHeaderCell {
  connectedCallback() {
    super.connectedCallback();
  }

  static styles = styles;
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DStructuredListHeaderCell;
